import { TJsonQuery } from '../../../../packages/JsonQuery';
import { tagsManagers } from '../managers';
import { parseTagValue } from './parseTagValue';

interface IParams {
  jsonQuery: TJsonQuery;
  removingTagValue: string;
}

export const modifyJsonQueryByRemovingTag = ({ jsonQuery, removingTagValue }: IParams) => {
  const [tagId, tagValue = ''] = parseTagValue(removingTagValue);

  const removingTagManager = tagsManagers.find(({ id }) => tagId === id);

  if (!removingTagManager) {
    return;
  }

  return removingTagManager.modifyJsonQueryByRemovingTag({ jsonQuery, removingTagValue: tagValue });
};
